import { AlertCircle } from "../../../../components/icons";
import { TFunction } from "i18next";
import { ActionStep, Player } from "../../types";
import { formatDisplayName } from "../../../../lib/nameFormat";

interface InstructionBannerProps {
  t: TFunction<"logger">;
  currentStep: ActionStep;
  selectedPlayer: Player | null;
  selectedAction: string | null;
  cardSelection?: string | null;
}

const InstructionBanner = ({
  t,
  currentStep,
  selectedPlayer,
  selectedAction,
  cardSelection,
}: InstructionBannerProps) => (
  <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-4 max-[1180px]:landscape:p-2">
    <div className="flex items-start gap-2">
      <AlertCircle className="text-blue-400 mt-0.5" size={20} />
      <div className="text-sm text-blue-200">
        {cardSelection &&
          t("instructionSelectCardPlayer", {
            card: cardSelection,
          })}
        {!cardSelection &&
          currentStep === "selectPlayer" &&
          t("instructionSelectPlayer")}
        {!cardSelection &&
          currentStep === "selectZone" &&
          t("instructionSelectZone", {
            player: formatDisplayName(selectedPlayer?.full_name),
          })}
        {!cardSelection &&
          currentStep === "selectQuickAction" &&
          t("instructionSelectQuickAction", {
            player: formatDisplayName(selectedPlayer?.full_name),
          })}
        {/* PMA-COCK-172 (client decision, 2026-09-08): the generic Shot
            destination tap now credits the blocker/GK under the tap itself
            (useActionFlow.ts), so every selectDestination action — Shot
            included — uses this same generic key again. The dedicated
            BlockedShot quick action and its own selectDestination copy
            (PMA-COCK-165) are retired.
            PMA-COCK-174: DirectShot's own destination step keeps its own
            copy key — every other selectDestination action, generic Shot
            included, keeps the key above unchanged. PMA-COCK-176/177
            (2026-09-09): DirectShot's tap is now on-target-only
            (Saved/Blocked/OnTarget), so this key's ES/EN text was reworded
            to match — the key itself is unchanged. "Shot Out" (restored,
            PMA-COCK-176) never reaches this step at all — it dispatches
            instantly from the quick-action grid, same as before. */}
        {!cardSelection &&
          currentStep === "selectDestination" &&
          selectedAction === "DirectShot" &&
          t("instructionSelectDestinationShot")}
        {/* EPIC-94 (AC1, lead review round 1, 2026-09-23): the generic
            "Click the destination for Goal" copy contradicted this step's
            own field hint ("Tap where the shot was taken from",
            ActionStage.tsx's `goalFieldHint` key) — a shot's origin is
            tapped, not clicked as a "destination" the way Pass/generic
            Shot use that word. Reuses the SAME key as the field hint (one
            source of truth for the wording) rather than a duplicate key
            that could drift out of sync with it. */}
        {!cardSelection &&
          currentStep === "selectDestination" &&
          selectedAction === "Goal" &&
          t("goalFieldHint", "Tap where the shot was taken from")}
        {/* EPIC-96 (T4, client follow-up 2026-09-24): the woodwork
            screenshot surfaced "Selecciona el resultado para Woodwork" —
            the RAW internal action key was interpolated straight into the
            banner instead of its own translated display name (the exact
            same lookup QuickActionMenu.tsx's own button label already uses
            for every action, `action<Name>` — e.g. `actionWoodwork` ->
            "Tiro al Palo"). Both interpolation sites below shared this bug
            (every non-DirectShot/Goal `selectDestination` action, and
            every `selectOutcome` action) — fixed at the source rather than
            only the one action name the client's screenshot happened to
            show, since the two keys never differed in cause. */}
        {!cardSelection &&
          currentStep === "selectDestination" &&
          selectedAction !== "DirectShot" &&
          selectedAction !== "Goal" &&
          t("instructionSelectDestination", {
            action: t(`action${selectedAction}`, selectedAction ?? ""),
          })}
        {!cardSelection &&
          currentStep === "selectAction" &&
          t("instructionSelectAction", {
            player: formatDisplayName(selectedPlayer?.full_name),
          })}
        {!cardSelection &&
          currentStep === "selectOutcome" &&
          t("instructionSelectOutcome", {
            action: t(`action${selectedAction}`, selectedAction ?? ""),
          })}
        {/* PMA-COCK-171: Foul's recipient step is a victim pick, not a pass
            — the generic pass-recipient wording was showing for it too.
            Pass/Duel/Penalty keep the generic key, unchanged. */}
        {!cardSelection &&
          currentStep === "selectRecipient" &&
          (selectedAction === "Foul"
            ? t("instructionSelectRecipientFoul")
            : t("instructionSelectRecipient"))}
      </div>
    </div>
  </div>
);

export default InstructionBanner;
